import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
const BottomMenuMobile = (props) => {
  const {
    history,
    setTvline,
    icon,
    nicName,
    loginId,
    setAuthId,
    setLoginId,
    apiUrl,
    pkg,
  } = props;
  const [showMore, setShowMore] = useState(false);
  const [ic, setIc] = useState('');
  const _shopping = () => {
    window.open('https://shop.aniplustv.com');
  };
  const _store = () => {
    history.push('/store');
  };
  const _program = () => {
    history.push('/list');
  };
  const _timetable = () => {
    setTvline(true);
  };
  const _more = () => {
    if (loginId === '' || loginId === null || loginId === undefined) {
      history.push('/login');
      console.log(loginId);
    } else {
      setShowMore(!showMore);
    }
  };
  const handleOutsideClose = (e) => {
    console.log(e.target.className);
    if (e.target.className !== 'clsMore') {
      e.stopPropagation();
      setShowMore(false);
    }
  };
  const goToMemberEdit = () => {
    history.push('/edit');
  };

  const setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  const logOut = () => {
    setCookie('account', '');
    setCookie('ad', '');
    setCookie('at', '');
    setCookie('rt', '');

    setLoginId('');
    setAuthId('');

    localStorage.removeItem('at');
    localStorage.removeItem('rt');

    window.scrollTo(0, 0);

    //clearCache()
    window.location.replace('/');
  };
  const goToCustomerCenter = () => {
    history.push('/customer/1');
  };
  const goToEvent = () => {
    history.push('/event');
  };
  const goToMemberShip = () => {
    history.push('/ticket');
  };
  const getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  const _getIcon = async () => {
    // const at = localStorage.getItem('at');
    const at = getCookie('at');
    const result = await axios.post(
      apiUrl + '/my_pkg',
      {
        params: {
          userid: loginId,
          pkg: pkg,
        },
      },
      {
        headers: {
          Authorization: 'bearer ' + at,
        },
      }
    );

    const intReturn = result.data[0].intReturn;
    // console.log(result);
    // console.log(intReturn);
    // console.log(result.data[0].myCharImg);
    if (intReturn === 0) {
      setIc(result.data[0].listData[0].myCharImg);
    }
  };
  const goToCompany = () => {
    window.open('https://company.aniplustv.com', '', '');
  };
  useEffect(() => {
    if (loginId) {
      _getIcon();
    }
  });
  useEffect(() => {
    document.addEventListener('click', handleOutsideClose);
    return () => {
      document.removeEventListener('click', handleOutsideClose);
    };
  }, []);

  return (
    <>
      <div className="modal_finfo" style={{ display: showMore ? '' : 'none' }}>
        <dl>
          <dt>
            <img src={ic} alt="" />
          </dt>
          <dd>
            <div className="name">{nicName}님</div>
            <div className="link">
              <a
                onClick={(e) => {
                  goToMemberEdit();
                }}
              >
                회원정보 수정
              </a>
              <a
                onClick={() => {
                  logOut();
                }}
              >
                로그아웃
              </a>
            </div>
          </dd>
        </dl>

        <ul>
          <li
            onClick={() => {
              goToCustomerCenter();
            }}
          >
            <a>고객센터</a>
          </li>
          <li
            onClick={() => {
              goToEvent();
            }}
          >
            <a>이벤트</a>
          </li>
          <li
            onClick={() => {
              goToMemberShip();
            }}
          >
            <a>포인트</a>
          </li>
          {/*}
          <li
            onClick={() => {
              goToCompany();
            }}
          >
            <a>회사소개</a>
          </li>
          */}
        </ul>
      </div>

      <div className="bottom-menu-mobile">
        <ul>
          <li onClick={_shopping}>
            <img src="/img/icons/shopping.svg" />
            <a href="#">쇼핑</a>
          </li>
          <li onClick={_store}>
            <img src="/img/icons/store.svg" />
            <a href="#">스토어</a>
          </li>
          <li onClick={_program}>
            <img src="/img/icons/program.svg" />
            <a href="#">프로그램</a>
          </li>
          <li onClick={_timetable}>
            <img src="/img/icons/tiemtable.svg" />
            <a href="#">편성표</a>
          </li>
          <li onClick={_more} className="clsMore">
            <img src="/img/icons/more.svg" className="clsMore" />
            <a className="clsMore">더보기</a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default shopContext(withRouter(BottomMenuMobile));
